import { useActiveCompany } from './useActiveCompany'

export default useActiveCompany
